export default __webpack_public_path__ + "static/media/netZoo_logo_v14.30363dd7.svg";